import { Tooltip } from '@wapharma/design-system';
import { formatCompactFriendlyDate, formatFriendlyDate } from '../utils/friendlyDate';
import styles from './FriendlyDate.module.css';

type FriendlyDateProps = {
  iso: string | null | undefined;
  compact?: boolean;
};

/** Relative French label; hover shows full date/time. */
export function FriendlyDate({ iso, compact = false }: FriendlyDateProps) {
  const { text, detail } = compact ? formatCompactFriendlyDate(iso) : formatFriendlyDate(iso);
  if (!detail) return <>{text}</>;
  const noWrapLabel = detail.replace(/ /g, '\u00A0');
  return (
    <Tooltip label={noWrapLabel} portal position="bottom">
      <span className={styles.linkish} tabIndex={0}>
        {text}
      </span>
    </Tooltip>
  );
}
